export const hiredPreventionTitle = 'Fusión contratado ahora en promoción';
export const hiredTitle = 'Fusión contratado';
export const MOBILE = 'mobile';
export const sureMsgChangeFusion = '¿Seguro que quieres cambiar de fusión?';
export const changeSmartphoneConditionText = 'Las condiciones de tu smartphone podrían cambiar';
export const legalInfoChangesText = 'Si tu terminal actual es de una gama no incluida en el Fusión que has solicitado, añadiremos el extra mensual correspondiente (máximo 10€) en tu Factura';
export const promoSpecialForYouText = 'Quédate en tu Fusión con una promo especial para ti';
export const selectedProductTitle = 'Fusión solicitado';
export const infoActualPromoDeprecated = 'Si actualmente estás disfrutando de una promoción sobre tu Fusión contratado, la perderás al contratar esta oferta.';
